import React from 'react'
import { t } from 'i18next'
import { GridItem } from '../common/grid/GridItem'
import { ControlledTextInput } from '../common/inputs/TextInput'
import { UseFormReturn } from 'react-hook-form'
import { Organisation } from '../../api/schemas/schema'
import { ControlledZipInput } from '../common/inputs/ControlledZipInput'
import { ControlledPhoneInput } from '../common/inputs/ControlledPhoneInput'

type InvoiceDetailsFormProps = {
   organisationForm: UseFormReturn<Organisation, any, Organisation>
}

export const InvoiceDetailsForm = ({ organisationForm }: InvoiceDetailsFormProps) => {
   const { control } = organisationForm
   return (
      <>
         <GridItem size="12/12">
            <ControlledTextInput required control={control} type="text" name={'invoiceName'} label={t('CompanyName')} />
         </GridItem>
         <GridItem size="12/12">
            <ControlledTextInput required control={control} type="text" name={'invoiceReference'} label={t('InvoiceReference')} />
         </GridItem>
         <GridItem size="12/12">
            <ControlledTextInput required control={control} type="text" name={'invoiceAddress'} label={t('InvoiceAddress')} />
         </GridItem>
         <GridItem size="6/12">
            <ControlledZipInput required control={control} name={'postalCode'} label={t('PostalCode')} />
         </GridItem>
         <GridItem size="6/12">
            <ControlledTextInput required control={control} type="text" name={'county'} label={t('County')} />
         </GridItem>
         <GridItem size="6/12">
            <ControlledPhoneInput required control={control} name={'phoneNumber'} label={t('PhoneNumber')} />
         </GridItem>
         <GridItem size="6/12">
            <ControlledTextInput required control={control} type="email" name={'email'} label={t('Email')} />
         </GridItem>
         <GridItem size="12/12">
            <ControlledTextInput multiline control={control} type="text" name={'otherInvoiceDetails'} label={t('OtherInvoiceDetails')} />
         </GridItem>
      </>
   )
}
